import { motion } from "framer-motion";
import { UserPlus, Database, Rocket } from "lucide-react";

const steps = [
  {
    n: "1",
    icon: UserPlus,
    title: "Solicita el acceso",
    desc: "Un formulario breve: nombre de la iglesia y tu correo. En minutos tienes el acceso en tu bandeja de entrada.",
  },
  {
    n: "2",
    icon: Database,
    title: "Explora con datos de ejemplo",
    desc: "14 días para explorar todo con calma: miembros, finanzas, eventos. Con datos de ejemplo para que veas cómo quedaría con la iglesia real.",
  },
  {
    n: "3",
    icon: Rocket,
    title: "Activa tu plan",
    desc: "Si encaja, eliges plan, defines roles e importas lo que ya tengas en hojas de cálculo. Si no, sin compromiso. Sin llamadas.",
  },
];

const fade = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.75 },
};

export default function StepsSection() {
  return (
    <section
      id="steps"
      data-testid="steps-section"
      className="relative py-20 md:py-32 overflow-hidden"
      style={{
        background:
          "linear-gradient(168deg, rgba(238,235,255,0.5) 0%, #FAFAFE 45%, #ffffff 100%)",
      }}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-12">
        <motion.div {...fade} className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold mb-4">
            Así de sencillo
          </p>
          <h2
            data-testid="steps-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-ink tracking-tight"
          >
            Tres pasos y ya estás dentro
          </h2>
          <p className="mt-5 text-xl text-ink-2 leading-relaxed">
            Sin reuniones previas. Sin instalaciones. Sin tener que convencer a nadie.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.75, delay: i * 0.1 }}
              className="relative flex flex-col items-center text-center"
              data-testid={`step-card-${i}`}
            >
              <span
                aria-hidden="true"
                className="absolute -top-8 left-1/2 -translate-x-1/2 font-display text-[8rem] md:text-[10rem] font-black leading-none text-violet-light select-none -z-10"
              >
                {step.n}
              </span>
              <div className="relative z-10 flex h-16 w-16 items-center justify-center rounded-2xl bg-violet-fuerte text-white shadow-[0_8px_24px_-8px_rgba(74,58,138,0.3)] mb-6 mt-8">
                <step.icon className="w-8 h-8" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-2xl font-bold text-ink mb-3 tracking-tight">
                {step.title}
              </h3>
              <p className="text-lg text-ink-2 leading-relaxed max-w-sm">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 w-[60%] h-px bg-gradient-to-r from-transparent via-violet-light to-transparent -z-10" />

        <motion.div {...fade} className="mt-14 md:mt-20 text-center">
          <a
            href="#cta"
            data-testid="steps-cta-button"
            className="inline-flex h-[52px] items-center justify-center rounded-xl bg-violet-fuerte px-8 text-[17px] font-semibold text-white shadow-[0_6px_24px_-6px_rgba(74,58,138,0.45)] transition-all duration-300 hover:bg-violet-oscuro hover:shadow-[0_10px_32px_-6px_rgba(74,58,138,0.5)] hover:-translate-y-0.5"
          >
            Empezar gratis
          </a>
        </motion.div>
      </div>
    </section>
  );
}
